import React, {useEffect} from "react";
import {
  ModalBackButton,
  ModalContainer,
} from "../../common/components/modules/modal/modalComponents";
import useRouter from "../../common/hooks/useRouter";
import useOrderPath from "../../checkout/hooks/useOrderPath";
import routes from "../../common/routes";
import Modal from "../../common/components/modules/modal/Modal";
import AuthenticationRequiredComponent from "../../common/components/utils/AuthenticationRequiredComponent";
import useOrderState from "src/core/checkout/hooks/useOrderState";
import OrderTipForm from "./OrderTipForm";
import Loader from "../../common/components/elements/Loader";
import Title from "src/core/common/components/modules/Title";

function OrderTip({isOpen, closeModal}) {
  const router = useRouter();
  const [orderState, ECommerceAction] = useOrderState();
  const [orderId] = useOrderPath(routes.userOrderTip);
  const {query} = router;
  const order = orderState.data;
  const back = query.back !== "false";

  function backOrClose() {
    back ? router.safeBack() : closeModal();
  }

  useEffect(() => {
    if (order && !order.isOnlinePayment()) {
      backOrClose();
    }
  }, [order, router]);

  useEffect(() => {
    if (!order) {
      ECommerceAction.loadOrder(orderId);
    }
  }, [ECommerceAction, order, orderId]);

  useEffect(() => {
    return () => {
      if (!query.keepOrder) {
        ECommerceAction.clearOrder();
      }
    };
  }, [ECommerceAction, query.keepOrder]);

  function onSuccess() {
    backOrClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={query.backOnClose ? router.safeBack() : closeModal}
    >
      {back && <ModalBackButton onClick={() => router.safeBack()} />}
      <ModalContainer>
        <Title>Rate Your Experience</Title>
        {order ? (
          <OrderTipForm
            order={order}
            rating={order.hasReviews() ? order.getFirstReview().rating : false}
            onSuccess={onSuccess}
            submitText={"Submit"}
          />
        ) : (
          <Loader />
        )}
      </ModalContainer>
    </Modal>
  );
}

function OrderTipWrapper({closeModal, ...props}) {
  return (
    <AuthenticationRequiredComponent onRequestCloseLoad={closeModal}>
      <OrderTip {...props} closeModal={closeModal} />
    </AuthenticationRequiredComponent>
  );
}
export default OrderTipWrapper;
